<template>
  <Label>
    <div class="flex flex-col grow rounded-md">
      <span class="text-sm/tight font-medium pb-1.5">{{ label }}</span>
      <textarea
        :value="modelValue"
        :placeholder="placeholder"
        :id="id"
        :name="name || id"
        :rows="rows"
        :maxlength="maxlength"
        :disabled="disabled"
        class="text-tertiary placeholder:text-placeholder text-style-base font-medium grow py-3 px-3.5 rounded-md border-primary resize-none disabled:opacity-60 disabled:cursor-not-allowed"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="handleBlur"
      />
    </div>
  </Label>
</template>

<script setup>
import { Label } from "radix-vue";

const emit = defineEmits(["update:modelValue", "blur"]);

defineProps({
  label: { type: String, required: true },
  modelValue: { type: String, default: "" },
  placeholder: { type: String, default: "" },
  id: { type: String, required: true },
  name: { type: String, required: false },
  rows: { type: [String, Number], default: 3 },
  maxlength: { type: [String, Number], required: false },
  disabled: { type: Boolean, default: false },
});

function handleBlur() {
  emit("blur");
}
</script>
